/*
 * TrackerBase Create Tracking Event Manager Controller
 * - Handles instantiating the Create Tracking Event modal dialog
 * - Handles creating the vent when the user clicks 'OK' in that dialog.
 * - Handles changing the view to the tracking event editor view 
 *   for the new event.
 *
 * Angular module: trackerbase-app.create-tracking-event-dialog.manager
 * Exposes controller: createTrackingEventCtrl
 */

import angular from "angular";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import ngAnimate from "angular-animate";
import ngAria from "angular-aria";

import uiRouter from "@uirouter/angularjs";
import uiBootstrap from "angular-ui-bootstrap";

import AuthServiceModule from "tbClient/services/auth";
import UserInfoServiceModule from "../../services/UserInfoService";
import TrackingCalendarDataServiceModule from "../../services/TrackingCalendarDataService";


import CreateTrackingEventDialogController from "./CreateTrackingEventDialogController";

const mUibModalSvc = new WeakMap();
const mUiRouterStateSvc = new WeakMap();
const mUserInfoSvc = new WeakMap();
const mTrackingCalendarDataSvc = new WeakMap();

const mIsSignedIn = new WeakMap();

class CreateTrackingEventDialogManagerController {
    constructor($scope, TbAuthService, $uibModal, $state, UserInfoService, TrackingCalendarData) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing Scope Service Dependency");
        Assert.StrictAssert(TbAuthService != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing Auth0 Service Dependency");
        Assert.StrictAssert($uibModal != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing UIB-Modal Service Dependency");
        Assert.StrictAssert($state != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing UI.Router State Service Dependency");
        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing User Info Service Dependency");
        Assert.StrictAssert(TrackingCalendarData != null, "Assertion Failure: Create Tracking Event Dialog Manager Missing Tracking Calendar Data Service Dependency");

        angular.noop($scope);
        mUibModalSvc.set(this, $uibModal);
        mUiRouterStateSvc.set(this, $state);
        mUserInfoSvc.set(this, UserInfoService);
        mTrackingCalendarDataSvc.set(this, TrackingCalendarData);

        mIsSignedIn.set(this, TbAuthService.isAuthenticated());

        $scope.$watch(
            () => TbAuthService.isAuthenticated(),
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    mIsSignedIn.set(this, TbAuthService.isAuthenticated());
                }
            },
            true
        );
    }

    get isSignedIn() {
        return mIsSignedIn.get(this);
    }

    launchCreateTrackingEventDialog() {

        let createEventModalInstance = mUibModalSvc.get(this).open({
            animation: true,
            template: CreateTrackingEventDialogController.template,
            controller: CreateTrackingEventDialogController,
            controllerAs: CreateTrackingEventDialogController.controllerAs,
            backdropClass: "tbIn",
            windowClass: "tbIn",
            size: "lg"
        });

        createEventModalInstance.result.then(
            (newTrackingEvent) => {

                mTrackingCalendarDataSvc.get(this)
                    .createEvent(newTrackingEvent)
                    .then(
                        (createdEvent) => {

                            mUiRouterStateSvc.get(this).go("trackingEvent", {
                                eventId: createdEvent.EventId
                            });

                        },
                        (response) => {
                            //TODO: Handle creation failure.
                            angular.noop(response);
                        }
                    );

            },
            () => {
                angular.noop();
            }
        );
    }
}

CreateTrackingEventDialogManagerController.$inject = [
    "$scope",
    "TbAuthService",
    "$uibModal",
    "$state",
    "UserInfoService",
    "TrackingCalendarData"
];

CreateTrackingEventDialogManagerController.dependencies = DependencyListBuilder([
    CreateTrackingEventDialogController.dependencies,
    [
        ngAnimate,
        ngAria,
        uiRouter,
        uiBootstrap,
        AuthServiceModule,
        UserInfoServiceModule,
        TrackingCalendarDataServiceModule
    ]
]);

CreateTrackingEventDialogManagerController.template = require("./CreateTrackingEventDialogManager.tpl.html");
CreateTrackingEventDialogManagerController.controllerAs = "createTrackingEventManager";

export default CreateTrackingEventDialogManagerController;



//////////////////
// WEBPACK FOOTER
// ./src/views/create-tracking-event-dialog/CreateTrackingEventDialogManager.js
// module id = 9Bj5
// module chunks = 1